// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <div>
    <a-card class="breadcrumb-card">
      <a-row>
        <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px">
          <breadcrumb :resource="{}">
            <template v-slot:end>
              <span>
                <a-button
                  :loading="isLoading"
                  style="margin-bottom: 5px"
                  shape="round"
                  size="small"
                  @click="fetchData({ irefresh: true })">
                  <template #icon><sync-outlined /></template>
                  {{ $t('label.refresh') }}
                </a-button>
              </span>
            </template>
          </breadcrumb>
        </a-col>
        <a-col :span="device === 'mobile' ? 24 : 12" class="text-right padding-btns" v-if="isLoading == 0">
          <a-button @click="disableIntegration()" v-if="isEnabled == 1" type="danger">Disable</a-button>
          <a-button @click="enableIntegration()" v-if="isEnabled == 0" type="primary">Enable</a-button>
          <a-button @click="resyncIntegration()" v-if="isEnabled == 1" type="secondary">Resync</a-button>
        </a-col>
      </a-row>
    </a-card>
    <ansible-params ref="params" :isReadOnly="isEnabled || isLoading" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/widgets/Breadcrumb'
import AnsibleParams from './configuration/AnsibleParams.vue'
import { mixinDevice } from '@/utils/mixin.js'
import { getAPI, postAPI } from '@/api'

export default {
  name: 'ManageAnsible',
  components: {
    Breadcrumb,
    AnsibleParams
  },
  props: {
  },
  mixins: [mixinDevice],
  data () {
    return {
      isEnabled: false,
      isLoading: true
    }
  },
  provide: function () {
    return {}
  },
  computed: {
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.isLoading = true
      getAPI('getAnsibleStatus', {}).then(json => {
        this.isEnabled = json.ansiblestatusresponse.payload.isEnabled
        this.isLoading = false
      }).catch(error => {
        this.$notifyError(error)
      })
    },

    enableIntegration () {
      var that = this
      if (that.isLoading) {
        return
      }
      that.isLoading = true

      var params = {}
      params.url = this.$refs.params.url
      params.organization = this.$refs.params.organization
      params.project = this.$refs.params.project
      params.username = this.$refs.params.username
      params.password = this.$refs.params.password
      params.prefix = this.$refs.params.prefix
      params.allowed_source_cidrs = this.$refs.params.allowedSourceCidrs

      postAPI('enableAnsible', params).then(json => {
        const jobId = json.configureansibleresponse.jobid
        this.$store.dispatch('AddAsyncJob', {
          title: this.$t('label.ansible.start.enable'),
          jobid: jobId,
          description: this.$t('label.ansible'),
          status: 'progress'
        })
        this.$pollJob({
          jobId,
          loadingMessage: `${this.$t('label.ansible.start.enable')}`,
          catchMessage: this.$t('error.fetching.async.job.result'),
          successMessage: `${this.$t('label.ansible.end.enable')}`,
          successMethod: function () {
            that.isEnabled = true
            that.isLoading = false
          },
          errorMethod: function () {
            that.isLoading = false
          }
        })
      }).catch(error => {
        this.$notifyError(error)
        this.isLoading = false
      })
    },
    async disableIntegration () {
      var that = this
      if (that.isLoading) {
        return
      }
      that.isLoading = true

      postAPI('disableAnsible', {}).then(json => {
        this.$notification.success({ message: this.$t('label.ansible.disable') })
        this.isEnabled = false
      }).catch(error => {
        this.$notifyError(error)
      }).finally(() => {
        that.isLoading = false
      })
    },
    resyncIntegration () {
      var that = this
      console.log(that.isLoading)
      if (that.isLoading) {
        return
      }
      that.isLoading = true

      postAPI('resyncAnsible', {}).then(json => {
        const jobId = json.configureansibleresponse.jobid
        this.$store.dispatch('AddAsyncJob', {
          title: this.$t('label.ansible.start.resync'),
          jobid: jobId,
          description: this.$t('label.ansible'),
          status: 'progress'
        })
        this.$pollJob({
          jobId,
          loadingMessage: `${this.$t('label.ansible.start.resync')}`,
          catchMessage: this.$t('error.fetching.async.job.result'),
          successMessage: `${this.$t('label.ansible.end.resync')}`,
          successMethod: function () {
            that.isLoading = false
          },
          errorMethod: function () {
            that.isLoading = false
          }
        })
      }).catch(error => {
        this.$notifyError(error)
      })
    }
  }
}
</script>

<style scoped>
  .breadcrumb-card {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -16px;
    margin-bottom: 12px;
  }
  .row-element {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ant-breadcrumb {
    vertical-align: text-bottom;
  }
  .padding-btns button {
    margin-left: 6px;
    margin-right: 6px;
  }
</style>
